module.exports = __webpack_public_path__ + "static/media/wheel-premium-warranty-template.d6ba7a49.png";